import { Component, Input, OnInit } from '@angular/core';
import { Subject } from "rxjs";
@Component({
  selector: 'app-modal',
  template: `
  <div (click)="onContainerClicked($event)" class="modal fade" tabindex="-1" [ngClass]="{'in': visibleAnimate}"
       [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <ng-content select=".app-modal-header"></ng-content>
        </div>
        <div class="modal-body">
          <ng-content select=".app-modal-body"></ng-content>
        </div>
        <div class="modal-footer">
          <ng-content select=".app-modal-footer"></ng-content>
        </div>
      </div>
    </div>
  </div>
  `,
  styles: [
    `
      .modal {
        background: rgba(0, 0, 0, 0.6);
        z-index: 1000 !important;
        overflow: scroll;
      }

      @media only screen and (min-width: 576px) {
        .modal-dialog {
          margin-top: 200px !important;
        }
      }

      .modal-footer {
        border-top: none;
      }

      .modal-header {
        background-color: #343a40;
        color: white;
        text-align: center;
        border-bottom: none;
      }
    `
  ]
})
export class ModalComponent implements OnInit {
  visible: boolean = false;
  @Input() visibleEvent: Subject<boolean>;
  private visibleAnimate = false;

  ngOnInit() {
    this.visibleEvent.subscribe(value => this.visible = value);
  }

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modal.component.ts